import { render, staticRenderFns } from "./SmartphoneWrapper.vue?vue&type=template&id=d963d2ca&"
import script from "./SmartphoneWrapper.vue?vue&type=script&lang=js&"
export * from "./SmartphoneWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SmartphoneWrapper.vue?vue&type=style&index=0&id=d963d2ca&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports